import Vue from "vue"
import helpers from "./_helpers";
import moment from "moment";
import defaults from "../mixins/default";

/* translation */
/* Vue.filter("T", function (value) {
	return helpers.fn.translate(value, arguments);
}); */

Vue.filter("date", function(value, format) {
    return moment(value).format(format);
});

Vue.filter("currency", function(value) {
    return Intl.NumberFormat("DE-de", {
        minimumFractionDigits: 2,
        style: "currency",
        currencyDisplay: "symbol",
        currency: "EUR"
    }).format(value).replace(/,00/g, "");
});

Vue.filter("travelerType", function(traveler) {
    switch (traveler.Type) {
        case "Adult":
            return this.T("adult");
        case "Child5":
            return this.T("Child5");
        case "Child14":
            return this.T("Child14");
    }

    return null;
});

Vue.filter("salutation", function(salutation) {
    switch (salutation) {
        case "Mr":
            return this.T("mr");
        case "Mrs":
            return this.T("mrs");
        case "Family":
            return this.T("family");
    }
})